import {TextStyle} from '@treatwell/design-tokens';
import clsx from 'clsx';
import React from 'react';
import {Text} from '../Text';
import styles from './Chip.module.css';

export type ChipColor = 'primary' | 'success' | 'info' | 'default';

export type ChipType = {
  text: string;
  textStyle?: TextStyle;
  color?: ChipColor;
  variant?: 'outlined' | 'filled';
  style?: 'pilled' | 'rounded';
  className?: string;
};

export const Chip = ({
  text,
  className,
  textStyle = 'caption',
  color = 'default',
  variant = 'outlined',
  style = 'pilled',
}: ChipType) => {
  return (
    <div
      className={clsx(
        styles.root,
        styles[color],
        styles[variant],
        styles[style],
        className
      )}
    >
      <Text type={textStyle}>{text}</Text>
    </div>
  );
};
